<template>

    <div class="bonuscode__selection">
          <div v-if="$root.detailsShow != 'bonuscode'">
            <Pencil />
            <span v-if="$root.bonus_code != ''">
                Vald bonuskod: <strong>{{$root.bonus_code}}</strong>
            </span>
            <span v-if="$root.bonus_code === ''">
                Ingen bonuskod vald
            </span>        
            <div style="float:right;display:inline-block;float: right;cursor: pointer;color: #57a3af;line-height: 1.33333rem;list-style-type: none;"><span class="bonuscode__textlink">Ändra</span> <!--<ChevronDown />--></div>
         </div>
         <div id="bonuscode-selection" class="modal" v-if="$root.detailsShow==='bonuscode'">
             <div class="content uppgifter">

                <form @submit.prevent="submit" id="add-bonus-code">
                <div class="uppgifter__block">
                    <h2 class="uppgifter__block-title">Lägg till en bonuskod</h2>
                    <p class="uppgifter__block-subtitle">Ange eventuell bonuskod. Bonuskoden aktiveras i samband med att vi bekräftar ditt avtal</p>

                    <label class="uppgifterText__field-wrapper">
                    <input id="uppgifterText__field_bonuscode" type="text" v-model="$root.bonus_code" placeholder="Bonuskod" class="uppgifterText__field uppgifterText__field_placeholder_style">
                    </label>
                    <span id="uppgifterText__feedback" class="uppgifterText__feedback" v-bind:class="{hidden : !$root.feedback.bonus_code }">Koden är inte längre giltig.</span>
                </div>
                <div class="step-nav">
                    <button type="submit" class="button button--with-icon step-nav__button">Fortsätt <Arrow /></button>
                </div>                      
                </form>

             </div>
         </div>

    </div>

</template>

<script>
  export default {
    methods: {
      submit() {
        this.$root.showDetails('bonuscode');

        let curThis = this;

        fetch(this.$root.publicUrl + '/api/bonuscode.php?bonus_code=' + this.$root.bonus_code).then(r => r.json()).then(r => {
          if (r != null && r.valid === true) {
              curThis.$root.bonus_data = r.data;
          }
        });

      },
    },
  }
  </script>
